export const SET_LANG = 'set_lang';
export const SECRET_KEY = '56c2dSaXpWenhNM1NCd3Z4Z3JK';
